import { tv } from 'tailwind-variants'

export const templateCardVariants = tv({
  slots: {
    container: 'flex flex-col'
  }
})
